/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { CallButtonVehicleFragmentDoc } from '../CallButton/CallButton.hook'

const defaultOptions = {} as const
export type CallControlsVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
}

export type FccJoinCabinToOperatorCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccJoinCabinToOperatorCallMutation = {
  __typename?: 'Mutation'
  fccJoinCabinToOperatorCall: string
}

export type FccJoinSafetyDriverCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccJoinSafetyDriverCallMutation = {
  __typename?: 'Mutation'
  fccJoinSafetyDriverCall: string
}

export type CallButtonStartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type CallButtonStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export type FccInitiateOperatorToCabinCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  emergencyStopAlertId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type FccInitiateOperatorToCabinCallMutation = {
  __typename?: 'Mutation'
  fccInitiateOperatorToCabinCall: string
}

export type FccInitiateOperatorToSafetyDriverCallMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type FccInitiateOperatorToSafetyDriverCallMutation = {
  __typename?: 'Mutation'
  fccInitiateOperatorToSafetyDriverCall: string
}

export type FccDeclineIncomingCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccDeclineIncomingCallMutation = {
  __typename?: 'Mutation'
  fccDeclineIncomingCall: any | null
}

export const CallControlsVehicleFragmentDoc = gql`
    fragment CallControlsVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      id
      type
    }
  }
  ...CallButtonVehicle
}
    ${CallButtonVehicleFragmentDoc}`
export const FccJoinCabinToOperatorCallDocument = gql`
    mutation FccJoinCabinToOperatorCall($vehicleId: ID!) {
  fccJoinCabinToOperatorCall(input: {vehicleId: $vehicleId})
}
    `
export type FccJoinCabinToOperatorCallMutationFn = Apollo.MutationFunction<
  FccJoinCabinToOperatorCallMutation,
  FccJoinCabinToOperatorCallMutationVariables
>

/**
 * __useFccJoinCabinToOperatorCallMutation__
 *
 * To run a mutation, you first call `useFccJoinCabinToOperatorCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccJoinCabinToOperatorCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccJoinCabinToOperatorCallMutation, { data, loading, error }] = useFccJoinCabinToOperatorCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccJoinCabinToOperatorCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccJoinCabinToOperatorCallMutation,
    FccJoinCabinToOperatorCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccJoinCabinToOperatorCallMutation,
    FccJoinCabinToOperatorCallMutationVariables
  >(FccJoinCabinToOperatorCallDocument, options)
}
export type FccJoinCabinToOperatorCallMutationHookResult = ReturnType<
  typeof useFccJoinCabinToOperatorCallMutation
>
export type FccJoinCabinToOperatorCallMutationResult =
  Apollo.MutationResult<FccJoinCabinToOperatorCallMutation>
export type FccJoinCabinToOperatorCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccJoinCabinToOperatorCallMutation,
    FccJoinCabinToOperatorCallMutationVariables
  >
export const FccJoinSafetyDriverCallDocument = gql`
    mutation FccJoinSafetyDriverCall($vehicleId: ID!) {
  fccJoinSafetyDriverCall(input: {vehicleId: $vehicleId})
}
    `
export type FccJoinSafetyDriverCallMutationFn = Apollo.MutationFunction<
  FccJoinSafetyDriverCallMutation,
  FccJoinSafetyDriverCallMutationVariables
>

/**
 * __useFccJoinSafetyDriverCallMutation__
 *
 * To run a mutation, you first call `useFccJoinSafetyDriverCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccJoinSafetyDriverCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccJoinSafetyDriverCallMutation, { data, loading, error }] = useFccJoinSafetyDriverCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccJoinSafetyDriverCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccJoinSafetyDriverCallMutation,
    FccJoinSafetyDriverCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccJoinSafetyDriverCallMutation,
    FccJoinSafetyDriverCallMutationVariables
  >(FccJoinSafetyDriverCallDocument, options)
}
export type FccJoinSafetyDriverCallMutationHookResult = ReturnType<
  typeof useFccJoinSafetyDriverCallMutation
>
export type FccJoinSafetyDriverCallMutationResult =
  Apollo.MutationResult<FccJoinSafetyDriverCallMutation>
export type FccJoinSafetyDriverCallMutationOptions = Apollo.BaseMutationOptions<
  FccJoinSafetyDriverCallMutation,
  FccJoinSafetyDriverCallMutationVariables
>
export const CallButtonStartHandlingVehicleDocument = gql`
    mutation CallButtonStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type CallButtonStartHandlingVehicleMutationFn = Apollo.MutationFunction<
  CallButtonStartHandlingVehicleMutation,
  CallButtonStartHandlingVehicleMutationVariables
>

/**
 * __useCallButtonStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useCallButtonStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallButtonStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callButtonStartHandlingVehicleMutation, { data, loading, error }] = useCallButtonStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCallButtonStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >(CallButtonStartHandlingVehicleDocument, options)
}
export type CallButtonStartHandlingVehicleMutationHookResult = ReturnType<
  typeof useCallButtonStartHandlingVehicleMutation
>
export type CallButtonStartHandlingVehicleMutationResult =
  Apollo.MutationResult<CallButtonStartHandlingVehicleMutation>
export type CallButtonStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >
export const FccInitiateOperatorToCabinCallDocument = gql`
    mutation FccInitiateOperatorToCabinCall($vehicleId: ID!, $emergencyStopAlertId: ID) {
  fccInitiateOperatorToCabinCall(
    input: {vehicleId: $vehicleId, emergencyStopAlertId: $emergencyStopAlertId}
  )
}
    `
export type FccInitiateOperatorToCabinCallMutationFn = Apollo.MutationFunction<
  FccInitiateOperatorToCabinCallMutation,
  FccInitiateOperatorToCabinCallMutationVariables
>

/**
 * __useFccInitiateOperatorToCabinCallMutation__
 *
 * To run a mutation, you first call `useFccInitiateOperatorToCabinCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccInitiateOperatorToCabinCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccInitiateOperatorToCabinCallMutation, { data, loading, error }] = useFccInitiateOperatorToCabinCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      emergencyStopAlertId: // value for 'emergencyStopAlertId'
 *   },
 * });
 */
export function useFccInitiateOperatorToCabinCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccInitiateOperatorToCabinCallMutation,
    FccInitiateOperatorToCabinCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccInitiateOperatorToCabinCallMutation,
    FccInitiateOperatorToCabinCallMutationVariables
  >(FccInitiateOperatorToCabinCallDocument, options)
}
export type FccInitiateOperatorToCabinCallMutationHookResult = ReturnType<
  typeof useFccInitiateOperatorToCabinCallMutation
>
export type FccInitiateOperatorToCabinCallMutationResult =
  Apollo.MutationResult<FccInitiateOperatorToCabinCallMutation>
export type FccInitiateOperatorToCabinCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccInitiateOperatorToCabinCallMutation,
    FccInitiateOperatorToCabinCallMutationVariables
  >
export const FccInitiateOperatorToSafetyDriverCallDocument = gql`
    mutation FccInitiateOperatorToSafetyDriverCall($vehicleId: ID!) {
  fccInitiateOperatorToSafetyDriverCall(input: {vehicleId: $vehicleId})
}
    `
export type FccInitiateOperatorToSafetyDriverCallMutationFn =
  Apollo.MutationFunction<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >

/**
 * __useFccInitiateOperatorToSafetyDriverCallMutation__
 *
 * To run a mutation, you first call `useFccInitiateOperatorToSafetyDriverCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccInitiateOperatorToSafetyDriverCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccInitiateOperatorToSafetyDriverCallMutation, { data, loading, error }] = useFccInitiateOperatorToSafetyDriverCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccInitiateOperatorToSafetyDriverCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >(FccInitiateOperatorToSafetyDriverCallDocument, options)
}
export type FccInitiateOperatorToSafetyDriverCallMutationHookResult =
  ReturnType<typeof useFccInitiateOperatorToSafetyDriverCallMutation>
export type FccInitiateOperatorToSafetyDriverCallMutationResult =
  Apollo.MutationResult<FccInitiateOperatorToSafetyDriverCallMutation>
export type FccInitiateOperatorToSafetyDriverCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >
export const FccDeclineIncomingCallDocument = gql`
    mutation FccDeclineIncomingCall($vehicleId: ID!) {
  fccDeclineIncomingCall(input: {vehicleId: $vehicleId})
}
    `
export type FccDeclineIncomingCallMutationFn = Apollo.MutationFunction<
  FccDeclineIncomingCallMutation,
  FccDeclineIncomingCallMutationVariables
>

/**
 * __useFccDeclineIncomingCallMutation__
 *
 * To run a mutation, you first call `useFccDeclineIncomingCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccDeclineIncomingCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccDeclineIncomingCallMutation, { data, loading, error }] = useFccDeclineIncomingCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccDeclineIncomingCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccDeclineIncomingCallMutation,
    FccDeclineIncomingCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccDeclineIncomingCallMutation,
    FccDeclineIncomingCallMutationVariables
  >(FccDeclineIncomingCallDocument, options)
}
export type FccDeclineIncomingCallMutationHookResult = ReturnType<
  typeof useFccDeclineIncomingCallMutation
>
export type FccDeclineIncomingCallMutationResult =
  Apollo.MutationResult<FccDeclineIncomingCallMutation>
export type FccDeclineIncomingCallMutationOptions = Apollo.BaseMutationOptions<
  FccDeclineIncomingCallMutation,
  FccDeclineIncomingCallMutationVariables
>
